import React from "react";
import "./Style.css";
import Header from "./Header";
const TermsAndConditions = () => {
  return (
    <div className="container">
      <Header />

      <div className="container">
        <div className="row">
          <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>

          <div className="col-lg-1O col-md-10 col-sm-10 col-xs-10">
            <div className="terms-cond">
              <h2>Terms & Conditions Of VMRDA</h2>
              <br />
              <ul>
                <li>Check-in Time : Based on VMRDA Conditions</li>

                <li>Check-out Time : Based On venue selection (IST)</li>
              </ul>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
